"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ANONYMOUS = '<<anonymous>>';
exports.ANONYMOUS = ANONYMOUS;

var getClassName = function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return ANONYMOUS;
  }

  return propValue.constructor.name;
};

exports.getClassName = getClassName;

var isEmpty = function isEmpty(o) {
  return o === null || o === undefined;
};

exports.isEmpty = isEmpty;

var includes = function includes(array, item) {
  return array.indexOf(item) > -1;
};

exports.includes = includes;